import Nullstack from 'nullstack';
export default function IconUnlink({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-unlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
  }), "   ", Nullstack.element("path", {
    d: "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "21",
    x2: "16",
    y2: "19"
  }), "   ", Nullstack.element("line", {
    x1: "19",
    y1: "16",
    x2: "21",
    y2: "16"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "8",
    x2: "5",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "3",
    x2: "8",
    y2: "5"
  }), " ");
}